export default () => {
    const iframe = document.getElementById('building-matterport-iframe');

    if (iframe) {
        // load Iframe on load to remove render blocking script for SSO
        const loadIframe = () => {
            iframe.setAttribute('src', iframe.getAttribute('data-src'));
            iframe.removeAttribute('data-src');
        }

        loadIframe();
    }
}